export type AemComponentProperties<T = unknown> = {
  ':items': Record<string, T>;
  ':itemsOrder': Array<string>;
  ':type': string;
  id: string;
};
